module.exports = {
    DELETE_WORK_REPORT: "Are you sure you want to delete this work report?",
    DRAFT_WORK_REPORT_NOTE: "You are in draft mode for your work report.",
}